import Image from './Image'

class Poster extends Image {}

export default Poster
